
export const shopArchiveURIs = {
  home: "/archives/shop",
  genre: "/archives/genre/",
  search: "/archives/shop/s/",
};

